import { render, staticRenderFns } from "./checkManageMentDetailPlatform.vue?vue&type=template&id=17866f59&"
import script from "./checkManageMentDetailPlatform.vue?vue&type=script&lang=js&"
export * from "./checkManageMentDetailPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports